var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKfintechLogin1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 94,
    viewBox: "0 0 486 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.072 84.4954V86.1905H122.87V87.7668H120.072V89.6054H123.235V91.24H117.983V82.863H123.235V84.4976H120.072V84.4954Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.175 91.2378L135.428 88.6727L133.887 91.2378H131.516L134.264 86.9775L131.454 82.8608H133.885L135.607 85.3901L137.122 82.8608H139.491L136.766 87.0852L139.601 91.2378H137.175Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.182 86.8879C153.954 87.2892 153.603 87.6143 153.13 87.861C152.657 88.1076 152.072 88.2309 151.372 88.2309H150.077V91.2378H147.988V82.8608H151.372C152.056 82.8608 152.634 82.9752 153.107 83.2061C153.58 83.4371 153.934 83.7555 154.17 84.1613C154.407 84.5672 154.524 85.0313 154.524 85.5582C154.524 86.0448 154.411 86.4865 154.182 86.8879ZM152.106 86.334C152.301 86.1502 152.4 85.8923 152.4 85.5582C152.4 85.2241 152.301 84.9663 152.106 84.7824C151.911 84.5986 151.613 84.5089 151.216 84.5089H150.079V86.6098H151.216C151.613 86.6076 151.909 86.5179 152.106 86.334Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.031 84.4954V86.1905H167.829V87.7668H165.031V89.6054H168.194V91.24H162.942V82.863H168.194V84.4976H165.031V84.4954Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.255 91.2378L179.471 88.0762H178.97V91.2378H176.881V82.8608H180.387C181.062 82.8608 181.64 82.9752 182.116 83.2061C182.593 83.4371 182.949 83.7532 183.185 84.1546C183.422 84.556 183.539 85.0044 183.539 85.4977C183.539 86.0538 183.378 86.5515 183.057 86.9888C182.735 87.426 182.26 87.7377 181.633 87.9193L183.612 91.2355H181.255V91.2378ZM178.97 86.6322H180.265C180.649 86.6322 180.936 86.5403 181.126 86.3587C181.317 86.1748 181.413 85.917 181.413 85.5829C181.413 85.2645 181.317 85.0134 181.126 84.8317C180.936 84.6479 180.649 84.5582 180.265 84.5582H178.97V86.6322Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.267 82.8608V91.2378H192.178V82.8608H194.267Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.201 84.4954V86.1905H208V87.7668H205.201V89.6054H208.365V91.24H203.112V82.863H208.365V84.4976H205.201V84.4954Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.724 91.2378H222.635L219.141 86.0717V91.2378H217.052V82.8608H219.141L222.635 88.0516V82.8608H224.724V91.2378Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.767 84.825C234.134 84.177 234.644 83.6725 235.3 83.3092C235.957 82.9482 236.698 82.7666 237.529 82.7666C238.546 82.7666 239.419 83.0289 240.144 83.5536C240.87 84.0783 241.354 84.7936 241.597 85.7017H239.302C239.13 85.3519 238.888 85.0851 238.574 84.9012C238.259 84.7173 237.904 84.6276 237.504 84.6276C236.861 84.6276 236.34 84.8474 235.941 85.2846C235.541 85.7218 235.342 86.3071 235.342 87.038C235.342 87.769 235.541 88.3542 235.941 88.7914C236.34 89.2287 236.861 89.4484 237.504 89.4484C237.904 89.4484 238.259 89.3565 238.574 89.1749C238.888 88.991 239.13 88.7264 239.302 88.3744H241.597C241.354 89.2802 240.87 89.9955 240.144 90.5157C239.419 91.0359 238.549 91.2982 237.529 91.2982C236.698 91.2982 235.955 91.1166 235.3 90.7556C234.644 90.3946 234.134 89.8901 233.767 89.2466C233.399 88.6031 233.216 87.8654 233.216 87.038C233.216 86.2106 233.399 85.473 233.767 84.825Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3 84.4954V86.1905H255.098V87.7668H252.3V89.6054H255.463V91.24H250.211V82.863H255.463V84.4976H252.3V84.4954Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.241 82.8608V84.4954H277.968V91.2378H275.879V84.4954H273.606V82.8608H280.241Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.996 91.2378L291.212 88.0762H290.712V91.2378H288.623V82.8608H292.128C292.803 82.8608 293.382 82.9752 293.857 83.2061C294.334 83.4371 294.69 83.7532 294.927 84.1546C295.163 84.556 295.28 85.0044 295.28 85.4977C295.28 86.0538 295.119 86.5515 294.798 86.9888C294.477 87.426 294.001 87.7377 293.375 87.9193L295.354 91.2355H292.996V91.2378ZM290.712 86.6322H292.006C292.39 86.6322 292.677 86.5403 292.867 86.3587C293.058 86.1748 293.154 85.917 293.154 85.5829C293.154 85.2645 293.058 85.0134 292.867 84.8317C292.677 84.6479 292.39 84.5582 292.006 84.5582H290.712V86.6322Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.256 89.7579H306.056L305.542 91.2378H303.354L306.458 82.8608H308.877L311.981 91.2378H309.77L309.256 89.7579ZM308.719 88.1839L307.656 85.1165L306.605 88.1839H308.719Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.925 91.2378H325.836L322.342 86.0717V91.2378H320.253V82.8608H322.342L325.836 88.0516V82.8608H327.925V91.2378Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.187 91.0249C337.691 90.8253 337.294 90.5316 336.995 90.1415C336.697 89.7513 336.541 89.2827 336.525 88.7333H338.749C338.781 89.0428 338.892 89.2804 339.08 89.4441C339.268 89.6078 339.511 89.6885 339.812 89.6885C340.122 89.6885 340.365 89.619 340.544 89.48C340.723 89.341 340.813 89.1482 340.813 88.9015C340.813 88.6952 340.742 88.5248 340.6 88.388C340.457 88.2535 340.283 88.1414 340.074 88.054C339.865 87.9665 339.571 87.8678 339.188 87.7557C338.634 87.5876 338.182 87.4217 337.831 87.2535C337.48 87.0853 337.179 86.8409 336.926 86.5135C336.674 86.1862 336.548 85.7624 336.548 85.2377C336.548 84.4574 336.837 83.8476 337.415 83.4058C337.994 82.9641 338.747 82.7444 339.677 82.7444C340.622 82.7444 341.382 82.9641 341.961 83.4058C342.539 83.8476 342.849 84.4619 342.888 85.2489H340.627C340.611 84.9776 340.51 84.7646 340.322 84.6099C340.134 84.4552 339.895 84.3767 339.601 84.3767C339.348 84.3767 339.144 84.4417 338.99 84.574C338.836 84.7063 338.758 84.8947 338.758 85.1413C338.758 85.4126 338.889 85.6234 339.149 85.7736C339.408 85.9238 339.817 86.0875 340.37 86.2624C340.923 86.4463 341.373 86.6212 341.72 86.7871C342.066 86.9553 342.365 87.1974 342.617 87.5158C342.87 87.8342 342.996 88.2445 342.996 88.7446C342.996 89.2221 342.872 89.6549 342.624 90.045C342.376 90.4352 342.016 90.7446 341.543 90.9756C341.07 91.2065 340.512 91.3209 339.869 91.3209C339.247 91.3231 338.685 91.2222 338.187 91.0249Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.197 82.8608V84.4954H353.703V86.2623H356.318V87.8498H353.703V91.2378H351.614V82.8608H357.197Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.466 90.7738C366.793 90.4083 366.261 89.8971 365.866 89.2401C365.471 88.5832 365.274 87.8455 365.274 87.0271C365.274 86.2087 365.471 85.471 365.866 84.8185C366.261 84.166 366.793 83.657 367.466 83.2915C368.139 82.9261 368.878 82.7422 369.684 82.7422C370.49 82.7422 371.229 82.9261 371.901 83.2915C372.574 83.657 373.102 84.166 373.49 84.8185C373.876 85.471 374.071 86.2064 374.071 87.0271C374.071 87.8477 373.876 88.5854 373.485 89.2401C373.095 89.8971 372.565 90.4083 371.897 90.7738C371.229 91.1393 370.492 91.3232 369.686 91.3232C368.878 91.3232 368.139 91.1393 367.466 90.7738ZM371.327 88.7917C371.738 88.3455 371.945 87.758 371.945 87.0248C371.945 86.2849 371.738 85.6952 371.327 85.2535C370.917 84.8118 370.368 84.592 369.684 84.592C368.99 84.592 368.439 84.8118 368.029 85.249C367.618 85.6862 367.411 86.2782 367.411 87.0271C367.411 87.767 367.618 88.3567 368.029 88.7984C368.439 89.2401 368.993 89.4599 369.684 89.4599C370.368 89.4599 370.917 89.2379 371.327 88.7917Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.934 91.2378L385.15 88.0762H384.649V91.2378H382.56V82.8608H386.066C386.741 82.8608 387.319 82.9752 387.794 83.2061C388.272 83.4371 388.628 83.7532 388.864 84.1546C389.101 84.556 389.218 85.0044 389.218 85.4977C389.218 86.0538 389.057 86.5515 388.736 86.9888C388.414 87.426 387.939 87.7377 387.312 87.9193L389.291 91.2355H386.934V91.2378ZM384.649 86.6322H385.944C386.328 86.6322 386.615 86.5403 386.805 86.3587C386.996 86.1748 387.092 85.917 387.092 85.5829C387.092 85.2645 386.996 85.0134 386.805 84.8317C386.615 84.6479 386.328 84.5582 385.944 84.5582H384.649V86.6322Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57 82.8608V91.2378H405.48V86.2129L403.561 91.2378H401.876L399.946 86.2017V91.2378H397.856V82.8608H400.324L402.73 88.6592L405.113 82.8608H407.57Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.741 89.7579H418.541L418.027 91.2378H415.839L418.943 82.8608H421.362L424.466 91.2378H422.255L421.741 89.7579ZM421.204 88.1839L420.141 85.1165L419.09 88.1839H421.204Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.908 82.8608V84.4954H436.636V91.2378H434.546V84.4954H432.274V82.8608H438.908Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.377 82.8608V91.2378H447.288V82.8608H449.377Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.061 90.7738C459.388 90.4083 458.856 89.8971 458.461 89.2401C458.066 88.5832 457.868 87.8455 457.868 87.0271C457.868 86.2087 458.066 85.471 458.461 84.8185C458.856 84.166 459.388 83.657 460.061 83.2915C460.733 82.9261 461.473 82.7422 462.278 82.7422C463.084 82.7422 463.823 82.9261 464.496 83.2915C465.169 83.657 465.697 84.166 466.085 84.8185C466.47 85.471 466.666 86.2064 466.666 87.0271C466.666 87.8477 466.47 88.5854 466.08 89.2401C465.69 89.8971 465.16 90.4083 464.492 90.7738C463.823 91.1393 463.087 91.3232 462.281 91.3232C461.473 91.3232 460.733 91.1393 460.061 90.7738ZM463.922 88.7917C464.333 88.3455 464.54 87.758 464.54 87.0248C464.54 86.2849 464.333 85.6952 463.922 85.2535C463.511 84.8118 462.963 84.592 462.278 84.592C461.585 84.592 461.034 84.8118 460.623 85.249C460.212 85.6862 460.006 86.2782 460.006 87.0271C460.006 87.767 460.212 88.3567 460.623 88.7984C461.034 89.2401 461.587 89.4599 462.278 89.4599C462.963 89.4599 463.511 89.2379 463.922 88.7917Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.83 91.2378H480.741L477.247 86.0717V91.2378H475.157V82.8608H477.247L480.741 88.0516V82.8608H482.83V91.2378Z",
    fill: "#1C2D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.709 78.3093H149.983L125.88 49.0058V78.3093H116.959V20.4062H125.88V48.8667L148.759 20.4062H159.622L136.312 48.4452L161.709 78.3093Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.673 78.3093V20.4062H202.717V28.4872H175.594V47.3196H199.407V55.331H175.594V78.3093H166.673Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.631 78.3093V20.4062H219.552V78.3093H210.631Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.92 78.3093V19.2112L272.073 59.8985C272.024 56.9477 271.976 54.1001 271.928 51.3601C271.88 48.6202 271.857 45.6806 271.857 42.5415V20.4063H280.562V79.7847L239.481 38.9584C239.529 41.9092 239.577 44.8039 239.625 47.6358C239.673 50.47 239.696 53.3624 239.696 56.3132V78.3071H230.92V78.3093Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.378 78.3093V28.4872H287.254V20.4062H330.567V28.4872H313.372V78.3093H304.378Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.257 78.3093V20.4062H373.375V28.4177H346.323V44.8599H368.841V52.7301H346.323V70.2978H374.454V78.3093H337.257Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.636 79.4353C405.223 79.4353 401.084 78.6617 397.225 77.1169C393.364 75.572 389.994 73.4508 387.117 70.7579C384.238 68.065 381.973 64.8901 380.317 61.2352C378.662 57.5804 377.836 53.6229 377.836 49.3605C377.836 45.098 378.662 41.1383 380.317 37.4857C381.973 33.8309 384.238 30.6581 387.117 27.963C389.996 25.2701 393.364 23.1624 397.225 21.6376C401.087 20.1151 405.246 19.3528 409.707 19.3528C413.926 19.3528 417.668 19.9156 420.931 21.039C424.193 22.1623 426.854 23.4046 428.917 24.7634V34.7412C427.767 33.665 426.447 32.6672 424.96 31.7546C423.472 30.842 421.89 30.0572 420.212 29.4003C418.532 28.7455 416.794 28.241 414.996 27.889C413.199 27.537 411.41 27.3621 409.636 27.3621C406.374 27.3621 403.364 27.9249 400.607 29.0482C397.847 30.1716 395.474 31.7299 393.483 33.721C391.493 35.7121 389.934 38.0418 388.807 40.7122C387.68 43.3827 387.117 46.264 387.117 49.356C387.117 52.448 387.68 55.3292 388.807 57.9997C389.934 60.6702 391.493 63.0021 393.483 64.991C395.474 66.982 397.847 68.5404 400.607 69.6637C403.364 70.7871 406.374 71.3499 409.636 71.3499C413.281 71.3499 416.819 70.6705 420.249 69.3117C423.679 67.9529 426.569 66.1973 428.917 64.0425V74.0204C426.759 75.3791 424.062 76.6213 420.823 77.7447C417.586 78.8725 413.855 79.4353 409.636 79.4353Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.844 78.3093V20.4062H447.765V44.7904H476.904V20.4062H485.826V78.3093H476.904V52.8018H447.765V78.3093H438.844Z",
    fill: "#2057A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6223 89.4287L109.372 88.1125L110.368 89.1933C110.8 89.6619 110.435 90.4063 109.79 90.3727L92.6223 89.4287Z",
    fill: "url(#paint0_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3278 2.2019L55.8614 13.3928L40.0784 67.9952L24.5732 72.233L44.3278 2.2019Z",
    fill: "url(#paint1_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53442 93.2381L6.11801 77.2892L63.7034 61.5107L76.1989 73.5739L2.53442 93.2381Z",
    fill: "url(#paint2_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3388 29.2385L109.374 88.1124L92.6224 89.4286L46.6763 45.0775L51.3388 29.2385Z",
    fill: "url(#paint3_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M6.11816 77.2892L63.7034 61.5107L76.199 73.5739L6.11816 77.2892Z",
    fill: "url(#paint4_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M44.3278 2.2019L40.0784 67.9952L24.5732 72.233L44.3278 2.2019Z",
    fill: "url(#paint5_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M51.3388 29.2385L92.6224 89.4286L46.6763 45.0775L51.3388 29.2385Z",
    fill: "url(#paint6_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8613 13.3929L45.9829 0.370076C45.6156 -0.114242 44.8351 0.044955 44.6973 0.632415L44.3254 2.20197L55.8613 13.3929Z",
    fill: "url(#paint7_linear_226_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11802 77.2893L2.53443 93.2382L1.07895 93.7113C0.50273 93.8996 -0.0413501 93.3503 0.17215 92.792L6.11802 77.2893Z",
    fill: "url(#paint8_linear_226_32)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_226_32",
    x1: 92.6232,
    y1: 89.2428,
    x2: 110.557,
    y2: 89.2428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2878,
    stopColor: "#09B0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#0495A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8119,
    stopColor: "#018593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_226_32",
    x1: 50.3831,
    y1: 9.35421,
    x2: 32.2134,
    y2: 69.2976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139FCE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3219,
    stopColor: "#139CCB",
    stopOpacity: 0.9322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5804,
    stopColor: "#1293C1",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8161,
    stopColor: "#1083B0",
    stopOpacity: 0.9816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_226_32",
    x1: 0.629505,
    y1: 86.7117,
    x2: 72.3191,
    y2: 65.7967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3501,
    stopColor: "#317CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6313,
    stopColor: "#2D72BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8877,
    stopColor: "#2561AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2057A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_226_32",
    x1: 103.461,
    y1: 90.3418,
    x2: 52.6453,
    y2: 38.3143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2561,
    stopColor: "#0ED1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4617,
    stopColor: "#0DC7CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6499,
    stopColor: "#0AB6BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8265,
    stopColor: "#069EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    stopColor: "#00808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_226_32",
    x1: 3.65329,
    y1: 85.5399,
    x2: 69.8554,
    y2: 66.7015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#3079C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6923,
    stopColor: "#2869B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2057A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_226_32",
    x1: 49.258,
    y1: 5.71895,
    x2: 32.9826,
    y2: 70.6044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#139FCE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2648,
    stopColor: "#129AC8",
    stopOpacity: 0.9265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6111,
    stopColor: "#118AB8",
    stopOpacity: 0.9611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E719D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_226_32",
    x1: 103.412,
    y1: 88.581,
    x2: 51.0359,
    y2: 37.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1881,
    stopColor: "#0ECED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#0BBEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7122,
    stopColor: "#06A3AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007F8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_226_32",
    x1: 45.0993,
    y1: 1.22216,
    x2: 55.6692,
    y2: 13.5816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E719D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3889,
    stopColor: "#118AB8",
    stopOpacity: 0.9611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7352,
    stopColor: "#129AC8",
    stopOpacity: 0.9265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#139FCE",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_226_32",
    x1: 0.123986,
    y1: 85.52,
    x2: 6.11816,
    y2: 85.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#337FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3077,
    stopColor: "#2B6DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6997,
    stopColor: "#235DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2057A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 93.9488,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKfintechLogin1);
export default __webpack_public_path__ + "static/media/Kfintech Login 1.fb5192a4e447818c86f97785fb19d7d1.svg";
export { ForwardRef as ReactComponent };